export default __webpack_public_path__ + "static/real2-702b025e74c79a0500f72ad1ee274dc2.png";